/* eslint-disable @typescript-eslint/no-use-before-define */
import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import AliceCarousel from "react-alice-carousel";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { AiFillHeart, AiOutlineHeart } from "react-icons/ai";
import Skeleton from "react-loading-skeleton";
import Fade from "react-reveal/Fade";
import { Link, NavLink, useSearchParams } from "react-router-dom";
import StarRatingComponent from "react-star-rating-component";
import Swal from "sweetalert2";
import aboutImg from "../../assets/images/appImages/aboutimg.png";
import Empty from "../../assets/images/appImages/category.png";
import Icon2 from "../../assets/images/icons/icon2.svg";
import { useAppDispatch, useAppSelector } from "../../redux/hook";
import { onSetUserToken } from "../../redux/slice/User.slice";
import { formatCurrency, getImage, truncateCaractere } from "../../utils/Utils";
import { useGetAllCategoryListQuery } from "../../utils/api/category/category.api";
import { useLazyFavoriteByUserQuery } from "../../utils/api/favories/favorie.api";
import {
  useGetProductListQuery,
  useGetProductsEnAvantQuery,
  useGetProductsPromoQuery,
  useGetVendeurByApiKeyQuery,
} from "../../utils/api/product/product.api";
import { usePagination, useSearch } from "../../utils/hooks";
import { ApiBaseUrl, VendeurApikey } from "../../utils/http";
import { AppLocalStorage } from "../../utils/storage";
import { Color } from "../../utils/theme";
import FrontFooter from "../shared/FrontFooter/FrontFooter";
import FrontHeader from "../shared/FrontHeader/FrontHeader";
import { ProductItemsSkeleton } from "../user/ParcoursAchat/ParcoursAchat";
import BannerHomepage from "./BannerHomepage";
import { BestSellersSection } from "./BestSellersSection";
import { ProductsSection } from "./ProductsSection";
import { WhyChooseYesshopSection } from "./WhyChooseYesshopSection";


export const responsiveI = {
  0: { items: 2 },
  992: { items: 3 },
  1024: { items: 4 },
};

export const responsiveII = {
  0: { items: 3 },
  992: { items: 3 },
  1024: { items: 7 },
};

const CategorieSkeleton = () => {
  return (
    <>
      {Array(4)
        .fill(4)
        .map((el, i) => (
          <div className="col-lg-3 col-md-3 mb-3 dis-flex" key={i}>
            <div className="item-stat-dashboad-view ">
              <div className="content-item-stat-dashboad-view mt-2">
                <Skeleton
                  className="titre-item-stat-dashboad-view mb-2"
                  width={`70%`}
                />
              </div>
              <div className="content-stat-dashboard-view">
                <div className="content-text-item-stat-dashboad-view">
                  <div className="icon-item-stat-dashboad-view">
                    <Skeleton
                      className="chiffre-item-stat-dashboad-view mb-1"
                      width={`70%`}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
    </>
  );
};

const HomePage = () => {
  const dispatch = useAppDispatch();
  const Remember = AppLocalStorage.getItem("remember");
  const UserRemember: any = AppLocalStorage.getItem("user");

  const { limit, page } = usePagination(12);
  let [searchParams, setSearchParams] = useSearchParams();
  const status = searchParams.get("status");
  const { data = { results: [] }, isLoading } = useGetProductListQuery({
    page: page,
    limit: limit,
  });

  const { data: produitsEnAvant } = useGetProductsEnAvantQuery({
    page: page,
    limit: limit,
  });

  // Query dédiée pour récupérer TOUS les produits en promo (limite 100)
  const { data: dataPromo, isLoading: isLoadingPromo } = useGetProductsPromoQuery({
    page: 1,
    limit: 100,
  });

  const { data: categories, isLoading: isLoadingCategorie } =
    useGetAllCategoryListQuery();
  React.useEffect(() => {
    if (status == "success") {
      Swal.fire({
        icon: "success",
        title: `Paiement effectué avec succès!`,
        iconColor: Color.success,
        showConfirmButton: false,
        timer: 3000,
      });
    }
    if (status == "error") {
      Swal.fire({
        icon: "error",
        title: "Erreur est survenue lors du paiement !",
        showConfirmButton: false,
        timer: 5000,
      });
    }
  }, [status]);

  React.useEffect(() => {
    if (Remember) {
      dispatch(
        onSetUserToken({
          user: UserRemember?.user,
          token: UserRemember?.token,
        })
      );
    }
  }, [Remember]);

  // Filtrer TOUS les produits en promo depuis la query dédiée (limit 100)
  const allProduitsEnPromo = (dataPromo?.results || []).filter(
    (produit: any) =>
      produit?.categorie?.promotion?.is_active ||
      produit?.sous_categorie?.promotion?.is_active ||
      produit?.promotion?.is_active
  );
  
  // Récupérer les produits mis en avant
  const produitsMisEnAvant = produitsEnAvant?.results || [];
  
  // Combiner les produits en promo et les produits mis en avant
  // Éviter les doublons en utilisant l'ID
  const allBestSellers = [
    ...allProduitsEnPromo,
    ...produitsMisEnAvant.filter(
      (produit: any) => !allProduitsEnPromo.some((p: any) => p.id === produit.id)
    )
  ];
  
  // Limiter à 4 produits pour l'affichage
  const bestSellers = allBestSellers.slice(0, 4);
  
  // Debug - afficher le nombre de produits trouvés
  console.log('🎁 Total produits en promo:', allProduitsEnPromo.length);
  console.log('⭐ Produits mis en avant:', produitsMisEnAvant.length);
  console.log('📦 Best Sellers affichés:', bestSellers.length);

  return (
    <div className="landing-page-component">
      <FrontHeader />
      <div className="page-content">
        <BannerHomepage />
        <div className="container-easy-market mb-5">
          {/* Section Nos Best Sellers - Refonte complète avec classes CSS dédiées */}
          <BestSellersSection
            bestSellers={bestSellers}
            allBestSellers={allBestSellers}
            isLoading={isLoadingPromo || !produitsEnAvant}
          />

          <div className="container-home-page my-5 mb-0">
            <div className="content-title-home-page pb-5">
              <div className="title-home-page-container">
                <Fade bottom>
                  <h3 className="title-home-page-theme text-center">
                    Catégories
                  </h3>
                </Fade>
              </div>
            </div>
            <div className="container-grid-categories">
              {isLoadingCategorie && <CategorieSkeleton />}
              <div className="categories-grid">
                {categories?.results?.map((item, index) => (
                  <div key={item.id} className="category-grid-item">
                    <Fade bottom delay={index * 50}>
                      <div className="category-item-wrapper">
                        <Link
                          state={{ catgoryId: item?.id }}
                          to={`/produits?categorie=${item?.slug}`}
                          className="category-card-link"
                        >
                          <div className="category-card">
                            <div className="category-card-image">
                              <img 
                                src={item?.images ? getImage(item?.images) : Empty}
                                alt={item?.nom}
                                className="category-card-bg-image"
                              />
                            </div>
                          </div>
                        </Link>
                        <h4 className="category-card-title">{item?.nom}</h4>
                      </div>
                    </Fade>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Section "Pourquoi choisir Yesshop ?" */}
          <WhyChooseYesshopSection />

          {/* Section Nos Produits - Même design que Best Sellers */}
          <ProductsSection
            title="Nos Produits"
            products={data?.results?.slice(Math.max(data?.results?.length - 12, 0)) || []}
            isLoading={isLoading}
            showViewMore={true}
            viewMoreText="Voir plus"
            viewMoreLink="/produits"
          />

          {/* Section Témoignages clients */}
          <div className="testimonials-section-wrapper">
            <div className="content-title-home-page">
              <div className="title-home-page-container">
                <Fade bottom>
                  <h3 className="title-home-page-theme text-center">
                    Ce que nos clients disent de nous
                  </h3>
                </Fade>
              </div>
            </div>
            <div className="testimonials-section">
              <div className="testimonials-grid">
              <Fade bottom delay={0}>
                <div className="testimonial-card">
                  <div className="testimonial-quote-icon">
                    <svg width="32" height="32" viewBox="0 0 24 24" fill="var(--primary-color)" xmlns="http://www.w3.org/2000/svg">
                      <path d="M6 17h3l2-4V7H5v6h3zm8 0h3l2-4V7h-6v6h3z"/>
                    </svg>
                  </div>
                  <p className="testimonial-text">
                    Très satisfaite de mes achats sur Yesshop ! Livraison rapide et produits conformes aux descriptions. Je recommande !
                  </p>
                  <div className="testimonial-footer">
                    <p className="testimonial-name">Fatou D</p>
                    <div className="testimonial-rating">
                    {[1, 2, 3, 4, 5].map((star) => (
                      <svg
                        key={star}
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill={star <= 5 ? "var(--primary-color)" : "none"}
                        stroke={star <= 5 ? "var(--primary-color)" : "#ccc"}
                        strokeWidth="2"
                      >
                        <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z"/>
                      </svg>
                    ))}
                    </div>
                  </div>
                </div>
              </Fade>
              <Fade bottom delay={100}>
                <div className="testimonial-card">
                  <div className="testimonial-quote-icon">
                    <svg width="32" height="32" viewBox="0 0 24 24" fill="var(--primary-color)" xmlns="http://www.w3.org/2000/svg">
                      <path d="M6 17h3l2-4V7H5v6h3zm8 0h3l2-4V7h-6v6h3z"/>
                    </svg>
                  </div>
                  <p className="testimonial-text">
                    Super marketplace ! Le site est facile à utiliser et le service client est réactif. Je commanderai encore.
                  </p>
                  <div className="testimonial-footer">
                    <p className="testimonial-name">Mamadou S</p>
                    <div className="testimonial-rating">
                    {[1, 2, 3, 4, 5].map((star) => (
                      <svg
                        key={star}
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill={star <= 5 ? "var(--primary-color)" : "none"}
                        stroke={star <= 5 ? "var(--primary-color)" : "#ccc"}
                        strokeWidth="2"
                      >
                        <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z"/>
                      </svg>
                    ))}
                    </div>
                  </div>
                </div>
              </Fade>
              <Fade bottom delay={200}>
                <div className="testimonial-card">
                  <div className="testimonial-quote-icon">
                    <svg width="32" height="32" viewBox="0 0 24 24" fill="var(--primary-color)" xmlns="http://www.w3.org/2000/svg">
                      <path d="M6 17h3l2-4V7H5v6h3zm8 0h3l2-4V7h-6v6h3z"/>
                    </svg>
                  </div>
                  <p className="testimonial-text">
                    J'adore Yesshop ! Les produits sont de qualité j'ai reçu mon colis en parfait état.
                  </p>
                  <div className="testimonial-footer">
                    <p className="testimonial-name">Fatou N</p>
                    <div className="testimonial-rating">
                    {[1, 2, 3, 4, 5].map((star) => (
                      <svg
                        key={star}
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill={star <= 3 ? "var(--primary-color)" : "none"}
                        stroke={star <= 3 ? "var(--primary-color)" : "#ccc"}
                        strokeWidth="2"
                      >
                        <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z"/>
                      </svg>
                    ))}
                    </div>
                  </div>
                </div>
              </Fade>
              </div>
            </div>
          </div>
        </div>
      </div>
      <FrontFooter />
    </div>
  );
};

export default HomePage;

export const ProductItem = ({ item }: { item: any }) => {
  const { user, token } = useAppSelector((s) => s?.user);
  const Vendeur = getVendeur();

  console.log('vendeur', Vendeur)

  const imgProd =
    item?.type == "taille_unique"
      ? item?.images[0]?.image
      : item?.variations && item?.variations[0]?.images
        ? item?.variations[0]?.images[0]?.image
        : null;

  const config = {
    headers: { Authorization: `Bearer ${token}` },
  };

  const [findBySlug, { data, isLoading }] = useLazyFavoriteByUserQuery();

  React.useEffect(() => {
    if (user?.slug) {
      findBySlug(user?.slug as string);
    }
  }, [user]);

  const handleAddFavoris = (id) => {
    let favorie = data?.find((x) => x?.produit?.id == id);

    let fd = new FormData();

    fd.append("user", user?.id);
    fd.append("produit", id);

    if (favorie) {
      axios
        .delete(ApiBaseUrl + `/api/favoris/${favorie?.slug}`, config)
        .then((response) => {
          findBySlug(user?.slug as string);
        })
        .catch((error) => {
          console.error(`Error: ${error}`);
        });
    } else {
      axios
        .post(ApiBaseUrl + "/api/favoris/", fd, config)
        .then((response) => {
          findBySlug(user?.slug as string);
        })
        .catch((error) => {
          console.error(`Error: ${error}`);
        });
    }
  };

  const isFavorite = (id) => {
    let favorie = data?.find((x) => x?.produit?.id == id);

    if (favorie) {
      return true;
    } else {
      return false;
    }
  };

  const onToggleFavorite = (id) => {
    if (!user?.slug) {
      Swal.fire({
        icon: "info",
        title: `Veuilliez vous connecter pour ajouter un produit au favoris .`,
        iconColor: Color.success,
        showConfirmButton: false,
        timer: 6000,
      });
    } else {
      handleAddFavoris(id);
    }
  };

  return (
    <Fade bottom>
      <div className="product-item-container" style={{ flexGrow: 1 }}>
        <NavLink
          to={`/produit/${item?.slug}`}
          state={item}
          className="no-link w-100"
        >
          {(item?.categorie?.promotion?.is_active ||
            item?.sous_categorie?.promotion?.is_active ||
            item?.promotion?.is_active) ? (
              <span className="statut-product-item">
                -
                {item?.categorie?.promotion?.taux ||
                  item?.sous_categorie?.promotion?.taux ||
                  item?.promotion?.taux}
                %
              </span>
            ) : item?.new === true ? (
            <span className="statut-product-item">Nouveau</span>
          ) : item?.stock == 0 ? (
            <span className="statut-product-rupture">Rupture de stock</span>
          ) : (
            ""
          )}

          <div className="content-img-product-item">
            <img
              loading="lazy"
              src={imgProd ? getImage(imgProd) : Empty}
              alt={item?.nom}
              className="img-product-item"
            />
          </div>
          <div className="container-body-product-item">
            <div className="content-element-body-product-item">
              <p className="name-product-item my-2 reduce_hg">
                {window.innerWidth < 720
                  ? truncateCaractere(item?.nom, 39)
                  : truncateCaractere(item?.nom, 72)}
              </p>
              <div className="content-price-product">
                {item?.categorie?.promotion?.is_active ||
                  item?.sous_categorie?.promotion?.is_active ||
                  item?.promotion?.is_active ? (
                  <>
                    <span className="price-product-item-promo pb-3">
                      {formatCurrency(
                        item?.prix -
                        (item?.prix *
                          (item?.categorie?.promotion?.taux ||
                            item?.sous_categorie?.promotion?.taux ||
                            item?.promotion?.taux)) /
                        100,
                        Vendeur?.devise
                      )}{" "}
                    </span>
                    <span className="price-product-item-bare pb-3">
                      {formatCurrency(item?.prix, Vendeur?.devise)}
                    </span>
                  </>
                ) : (
                  <p className="price-product-item d-flex">
                    {formatCurrency(item?.prix, Vendeur?.devise)}
                  </p>
                )}
              </div>
            </div>
            <div className="container-cta-chat-produit">
              {item?.stock > 0 ? (
                <div className="content-btn-achat-produit w-90">
                  <NavLink
                    to={`/produit/${item?.slug}`}
                    className="btn btn-theme w-100"
                  >
                    Acheter
                  </NavLink>
                </div>
              ) : (
                <div className="content-btn-achat-produit w-90">
                  <button className="btn btn-theme-outline w-100 disabled">
                    Acheter
                  </button>
                </div>
              )}
              {/* <div className="content-btn-add-to-panier">
                {item.rupture === false ? (
                <button 
                  className={`
                    btn btn-theme-outline ${isAddedToCart ? 'added_to_card' : ''}
                  `}
                  onClick={() => setIsAddedToCart(!isAddedToCart)}
                >
                  {isAddedToCart ? <BsCartCheck /> : <FiShoppingCart />}
                </button>
                 ) : (
                  <button 
                  className="btn btn-theme-outline disabled"
                >
                  {isAddedToCart ? <BsCartCheck /> : <FiShoppingCart />}
                </button>
                 )}
              </div> */}
            </div>
          </div>
        </NavLink>
        <button
          disabled={isLoading}
          className="btn icon-fav-product"
          id={item?.id}
          aria-label="Ajouter au favoris"
          onClick={() => onToggleFavorite(item?.id)}
        >
          {isFavorite(item?.id) ? (
            <AiFillHeart style={{ color: "#E58924" }} />
          ) : (
            <AiOutlineHeart />
          )}
        </button>
      </div>
    </Fade>
  );
};

export const ProductItemSkeleton = () => {
  return (
    <>
      {Array(12)
        .fill(12)
        .map((item, i) => (
          <div className="col-product-item" key={i}>
            <div
              className="product-item-container"
              style={{ border: "1px solid #ebebeb", textAlign: "center" }}
            >
              <div className="content-img-product-item">
                <Skeleton className="img-product-item" />
              </div>
              <div className="content-btn-buy-product-item py-3">
                <Skeleton
                  className="btn btn-buy-product-item bg-transparent"
                  width={`50%`}
                />
              </div>
              <div className="text-center">
                <Skeleton
                  className="price-product-item"
                  width={`60%`}
                  height={20}
                />
                <Skeleton
                  className="name-prduct fs-15"
                  width={`70%`}
                  height={15}
                />
                <div className="content-rate-product">
                  <StarRatingComponent
                    name="rate2"
                    starCount={5}
                    value={0}
                    starColor="#000000"
                    emptyStarColor="#D4D6D5"
                  />
                </div>
              </div>
            </div>
          </div>
        ))}
    </>
  );
};

export const getVendeur = () => {
  const { data: vendeur } = useGetVendeurByApiKeyQuery(VendeurApikey);

  // Valeur par défaut si vendeur non disponible (mode dégradé)
  return vendeur || { devise: 'XOF' };
};
